import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentDTO } from '../../../model/ApartmentDTO';

export interface Link {
	rel: string,
	href: string,
	sizes: string,
	type: string
}

@Block() @Component
export class PageMetaApartmentBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;

	mounted() {
		const iconsDefault: string = `
		rel: "icon", sizes: "16x16", type: "image/png", href: "/wms3/favicon-16x16.png";
		rel: "icon", sizes: "32x32", type: "image/png", href: "/wms3/favicon-32x32.png";
		rel: "icon", sizes: "192x192", type: "image/png", href: "/wms3/android-chrome-192x192.png";
		rel: "icon", sizes: "512x512", type: "image/png", href: "/wms3/android-chrome-512x512.png";
		rel: "apple-touch-icon", sizes: "180x180", type: "image/png", href: "/wms3/apple-touch-icon-180x180.png";
		rel: "icon", href: "/wms3/favicon.ico"
		`;

		const mainScript = this.getText('page-main-script');
		const scripts = this.getText('page-scripts').split(';');
		const icons = (this.getText('page-icons') || iconsDefault).split(';').map(i => i.trim());

		this.removeExistingIcons();

		Promise.all(this.parseIcon(icons).map(i => this.loadIcon(i)))
	}

	get titleText(): string {
		let cityName = this.apartment.location.city;
		if (this.apartment.location.cityPart) {
			cityName += " - " + this.apartment.location.cityPart;
		}

		return this.getText((this.apartment.isStudio ? "page-title-studio" : "page-title-apartment"), [
			this.apartment.housingBlock.name,
			this.apartment.number,
			this.apartment.layoutLabel + (this.apartment.secondaryLayoutLabel ? ' (' + this.apartment.secondaryLayoutLabel + ')' : ''),
			cityName,
			this.apartment.location.name
		]);
	}

	get descriptionText(): string  {
		return this.getText(`page-description-${(this.apartment.isStudio ? "studio" : "apartment")}`, [
			this.apartment.housingBlock.name,
			this.apartment.number,
			this.apartment.layoutLabel + (this.apartment.secondaryLayoutLabel ? ' (' + this.apartment.secondaryLayoutLabel + ')' : ''),
			this.apartment.floor.label,
			this.apartment.innerFloorArea
		]);
	}

	removeExistingIcons() {
		document.head
			.querySelectorAll('link[data-dynamic-favicon]')
			.forEach(el => el.remove());
	}

	loadIcon(linkString: any) {
		return new Promise((resolve, reject) => {
			const l = linkString as Link;
			const link = document.createElement('link');
			link.rel = l.rel;
			link.href = l.href;
			link.setAttribute('data-dynamic-favicon', 'true');

			if (l.sizes) {
				link.setAttribute('sizes', l.sizes);
			}

			if (l.type) {
				link.type = l.type
			}

			document.head.appendChild(link);
		}).then(() => console.log("link loaded"));
	}

	parseIcon(icons: string[]) {
		return icons.map(i => {
			const obj: any = {};
			const regex = /(\w+):\s*"(.*?)"/g;
			let match;

			while ((match = regex.exec(i)) !== null) {
				const [, key, value] = match;
				obj[key] = value;
			}

			return obj as Link;
		});
	}
}

export default PageMetaApartmentBlock;
